import React from 'react';
import { BellIcon, HomeIcon, IdCardIcon, LayoutGridIcon, SparklesIcon, UserRoundIcon } from 'lucide-react';
import { citizenFirstName, mobileItems } from '../../data/espace';
export function PhoneMockup() {
  return <div aria-hidden="true" className="mx-auto w-[280px] rounded-[2.5rem] border-[10px] border-ville-navy bg-white shadow-2xl shadow-ville-navy/25" data-id="element-1480" data-mp="1s1i2vy60sm49">
      <div className="flex h-[560px] flex-col overflow-hidden rounded-[1.8rem]" data-id="element-1481" data-mp="2kpdyezjus7zg">
        <div className="flex items-center justify-between px-5 pt-5" data-id="element-1482" data-mp="2kn9skc2e8ywj">
          <span className="text-[15px] font-extrabold text-ville-navy" data-id="element-1483" data-mp="2pnfs0eewnpp6">Brossard</span>
          <span className="relative grid h-8 w-8 place-items-center rounded-full bg-slate-100 text-ville-navy" data-id="element-1484" data-mp="2aq576egdh7gs">
            <BellIcon className="h-4 w-4" data-id="element-1485" data-mp="2fo6pgx5z52r7" />
            <span className="absolute -right-0.5 -top-0.5 h-3 w-3 rounded-full bg-red-600 ring-2 ring-white" data-id="element-1486" data-mp="zc1dl9dp5lc9" />
          </span>
        </div>

        <div className="px-5 pt-5" data-id="element-1487" data-mp="14bnuptwnblqc">
          <p className="text-xl font-extrabold tracking-tight text-ville-navy" data-id="element-1488" data-mp="148i42a8dcbsi">Bonjour {citizenFirstName}</p>
          <div className="mt-3 flex items-center gap-2 rounded-full border border-slate-200 px-3 py-2" data-id="element-1489" data-mp="2vmwvfi14uiqq">
            <SparklesIcon className="h-4 w-4 text-ville-indigo" data-id="element-1490" data-mp="39mg1m5advk0e" />
            <span className="text-xs text-slate-400" data-id="element-1491" data-mp="39nzf5o4nngyh">Que puis-je faire pour vous ?</span>
          </div>
        </div>

        <div className="mt-5 flex-1 px-5" data-id="element-1492" data-mp="34pxwh4b55jnj">
          <p className="text-xs font-bold uppercase tracking-wider text-slate-500" data-id="element-1493" data-mp="3jju574b7keba">Pour vous</p>
          <ul className="mt-2.5 space-y-2.5" data-id="element-1494" data-mp="3ekpwsfw3ykm0">
            <li className="rounded-2xl border-l-4 border-red-600 bg-slate-50 px-4 py-3" data-id="element-1495" data-mp="3ejohu0bz1dz0">
              <p className="text-[11px] font-bold uppercase tracking-wider text-red-600" data-id="element-1496" data-mp="3sceb8pttxl65">Urgent</p>
              <p className="text-sm font-bold text-ville-navy" data-id="element-1497" data-mp="3ocdqyok1ufr6">Avis d’ébullition</p>
              <p className="text-xs text-slate-500" data-id="element-1498" data-mp="66h99m8g0k0p">4590, rue Bourgogne</p>
            </li>
            {mobileItems.map(item => <li key={item.id} className="rounded-2xl border border-slate-200 px-4 py-3" data-id="element-1499" data-mp="151rq45h4vn2">
                <p className="text-sm font-bold text-ville-navy" data-id="element-1500" data-mp="2ux1cm94g6nyb">{item.eyebrow}</p>
                <p className="text-xs text-slate-500" data-id="element-1501" data-mp="2z0pkyu0wlnkm">{item.detail}</p>
              </li>)}
          </ul>
        </div>

        <nav className="mt-4 flex items-end justify-between border-t border-slate-100 px-5 pb-5 pt-3" data-id="element-1502" data-mp="38q98iczka5lt">
          {[{
          icon: HomeIcon,
          label: 'Accueil',
          active: true
        }, {
          icon: IdCardIcon,
          label: 'Carte',
          active: false
        }].map(tab => <span key={tab.label} className={`flex w-12 flex-col items-center gap-1 text-[10px] font-semibold ${tab.active ? 'text-ville-navy' : 'text-slate-400'}`} data-id="element-1503" data-mp="3iqjiloqauwwr">
              <tab.icon className="h-5 w-5" data-id="element-1504" data-mp="1sciykplrgn49" />
              {tab.label}
            </span>)}

          <span className="flex w-12 flex-col items-center gap-1 text-[10px] font-bold text-ville-indigo" data-id="element-1505" data-mp="1xakkrjehh2jy">
            <span className="grid h-11 w-11 -translate-y-2 place-items-center rounded-full bg-ville-indigo text-white shadow-lg shadow-ville-indigo/40" data-id="element-1506" data-mp="1pruuha7d5yai">
              <SparklesIcon className="h-5 w-5" data-id="element-1507" data-mp="1kz1n0ekigbuq" />
            </span>
            <span className="-mt-1" data-id="element-1508" data-mp="1g2b6xr8phg9b">ATNA</span>
          </span>

          {[{
          icon: LayoutGridIcon,
          label: 'Services'
        }, {
          icon: UserRoundIcon,
          label: 'Profil'
        }].map(tab => <span key={tab.label} className="flex w-12 flex-col items-center gap-1 text-[10px] font-semibold text-slate-400" data-id="element-1509" data-mp="28ocro74zeqe5">
              <tab.icon className="h-5 w-5" data-id="element-1510" data-mp="1ys9hqf3w1ngn" />
              {tab.label}
            </span>)}
        </nav>
      </div>
    </div>;
}